import { useDirectoryContext } from '@/features/drive/entities/directory/directory-context'
import { useMoveNodesMutation } from '@/api/nodes/mutations/move/move-nodes-mutation'
import { toast } from '@/features/toast/toast'

export const useMoveNode = () => {
    const { content } = useDirectoryContext()

    const { mutateAsync: moveNodeAsync } = useMoveNodesMutation({
        nodeContentQueryKey: content.nodeContentQueryKey,
        sendToastSuccess: (count) => toast.success(`Successfully moved ${count} ${count > 1 ? 'items' : 'item'}`),
        sendToastError: (count) => toast.error(`An error occurred while moving the ${count > 1 ? 'items' : 'item'}`),
    })

    return { moveNodes: moveNodeAsync }
}
